import React, { useState } from "react";
import { Link } from "react-router-dom";
import { fetchRecentFamilies } from "../../service/FamilyApi";
import '../general/General.css';
import { Loading } from "../../components/shared";
import { convertTimestampToDate, useCheckAccess } from "../../utils/Utilities";

function RecentPendingFamilyList() {
  const [loading, setLoading] = useState(false);
  const [recentFamilies, setRecentFamilies] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showFamilies, setShowFamilies] = useState(false); // New state to control visibility

  useCheckAccess('FamilyRO');

  const handleFetchFamilies = () => {
    setLoading(true);
    fetchRecentFamilies(setRecentFamilies, setLoading, setErrorMessage, 'pending');
    setShowFamilies(true); // Show families after fetching
  };

  if (loading) {
    return (
      <div className="general_body">
        <Loading />
      </div>
    );
  }

  if (errorMessage) {
    return (
      <div className="general_body">
        <Loading />
      </div>
    );
  }

  return (
    <>
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
           
            <button onClick={handleFetchFamilies}>நிலுவையில் உள்ள குடும்பங்களைக் காட்டு.</button>
            <br />
            {showFamilies && recentFamilies && (
              <>
                <h2>சமீபத்தில் சேர்க்கப்பட்ட குடும்பங்கள்</h2>
                <br />
                {recentFamilies.length > 0 ? (
                  <div className="table-container">
                    <table className="table" aria-label="Recent Families">
                      <thead>
                        <tr>
                          <th>குடும்ப எண்</th>
                          <th>குடும்ப தலைவர்</th>
                          <th>புதுப்பிக்கப்பட்ட தேதி</th>
                          <th>திருத்த</th>
                        </tr>
                      </thead>
                      <tbody>
                        {recentFamilies.map((family) => (
                          <tr key={family.id}>
                            <td>

                              <span style={{ color: family.status === 'draft' || family.status === 'inactive' ? 'red' : 'inherit' }}>
                                {family.id} ({family.status})
                              </span>

                              <br />
                              {family.kootamName}

                            </td>
                            <td>
                              {family.familyHeadFirstName ? `${family.familyHeadFirstName}` : "தலைவர் பெயர் இல்லை"}
                              <br />
                              <span style={{ color: family.familyHeadAadhar?.startsWith('TMP') ? 'red' : 'inherit' }}>
                                {family.familyHeadAadhar || "ஆதார் எண் இல்லை"}
                              </span>

                              <br />
                              {family.permanentAddressName_tamil}{','}{family.permanentAddressBlock_tamil}{','}{family.permanentAddressDistrict_tamil}
                            </td>
                            <td>{convertTimestampToDate(family.updatedAt).toLocaleString()}</td>
                            <td>
                              <Link to={`/family/view/${family.id}`}>பார்க்க</Link>
                              <br />
                              <br />
                              <Link to={`/family/update/${family.id}`}>திருத்த</Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p>இணைக்கப்பட்ட (pending) சமீபத்திய குடும்பங்கள் இல்லை.</p>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default RecentPendingFamilyList;